/**
 * AccountExecutiveLabel — "Account Executive: {name}" for intake / pending-approval screens (T-12).
 *
 * The Account Executive replaces the HubSpot owner. The owner is shown ONLY when Oscar sent no AE,
 * so legacy HubSpot-webhook rows still render something. The name links to `mailto:` when an email
 * is known; an email-only AE renders the email as the link text.
 */
import type { OscarIntake } from "@/types/intake";
import { intakeAccountExecutive } from "@/types/intake";

export interface AccountExecutiveLabelProps {
  intake: Pick<
    OscarIntake,
    | "account_executive"
    | "account_executive_name"
    | "account_executive_email"
    | "hubspot_owner_name"
  >;
}

export function AccountExecutiveLabel({
  intake,
}: AccountExecutiveLabelProps): JSX.Element {
  const ae = intakeAccountExecutive(intake);

  if (!ae) {
    return (
      <span>
        HubSpot owner: {intake.hubspot_owner_name?.trim() || "Unknown"}
      </span>
    );
  }

  const label = ae.name ?? ae.email ?? "";
  return (
    <span>
      Account Executive:{" "}
      {ae.email ? (
        <a
          href={`mailto:${ae.email}`}
          className="font-medium text-primary hover:underline"
          title={ae.email}
        >
          {label}
        </a>
      ) : (
        <span className="font-medium text-text-primary">{label}</span>
      )}
    </span>
  );
}

export default AccountExecutiveLabel;
